import { Div, Button, router } from '@codesuma/baseline'
import { SheetPage } from '../../components/sheet-page'
import { DatePicker } from '../../components/date-picker'
import { System, IDateParts, IConverted, SYSTEMS, SYSTEM_NAMES, convert, parts, format } from '../../services/convert'
import { J_WEEKDAYS } from '../../configs/names'
import calendar from '../../services/calendar'
import style from './index.module.css'

// Date converter (route /converter): pick a date in one calendar and read it in
// the other two, then jump to that day in the app's calendar. Conversion runs
// through services/hijri, so the moon-sighting adjustments apply here exactly
// as they do in the month grid.
export const ConverterPage = () => {
    const base = SheetPage('تبدیل تاریخ')

    let system: System = 'jalaali'
    const t = calendar.today()
    let result: IConverted = convert('gregorian', { year: t.gy, month: t.gm, day: t.gd })

    // Which calendar the user is typing in.
    const tabs = Div()
    tabs.addClass(style.tabs)
    const tabButtons = SYSTEMS.map(s => {
        const tab = Button(SYSTEM_NAMES[s])
        tab.addClass(style.tab)
        tab.on('click', () => {
            if (system === s) return
            system = s
            // The picker is rebuilt because month names, day counts and the
            // year range all belong to the system; it is seeded with the date
            // already on screen, so switching calendars keeps the same day.
            mountPicker()
        })
        tabs.append(tab)
        return tab
    })
    base.append(tabs)

    const holder = Div()
    holder.addClass(style.holder)
    base.append(holder)

    const weekday = Div()
    weekday.addClass(style.weekday)
    base.append(weekday)

    const rows = Div()
    rows.addClass(style.rows)
    base.append(rows)

    const open = Button('نمایش در تقویم')
    open.addClass(style.open)
    open.on('click', () => router.goto(`/day?d=${result.g.gy}-${result.g.gm}-${result.g.gd}`))
    base.append(open)

    // One result line per calendar, including the one being typed in — seeing
    // it echoed back confirms the picker read the date the way it was meant.
    const row = (of: System) => {
        const line = Div()
        line.addClass(style.row)
        const label = Div(SYSTEM_NAMES[of])
        label.addClass(style.label)
        const value = Div(format(of, result))
        value.addClass(style.value)
        line.toggleClass(style.source, of === system)
        line.append(label, value)
        return line
    }

    const render = () => {
        tabButtons.forEach((tab, i) => tab.toggleClass(style.active, SYSTEMS[i] === system))
        weekday.text(J_WEEKDAYS[result.wd])
        rows.empty()
        rows.append(...SYSTEMS.map(row))
    }

    function mountPicker() {
        holder.empty()
        const picker = DatePicker(system, parts(system, result))
        picker.on('pick', (picked: IDateParts) => {
            result = convert(system, picked)
            render()
        })
        holder.append(picker)
        render()
    }

    mountPicker()

    return base
}
